import type React from 'react';
import { connect } from '../components/runtime-context';
import { getPostPageSectionUrl } from '../store/topology/topology-selectors';

export type WithSectionUrl = {
  sectionUrl: string;
};

const withSectionUrl = <P extends WithSectionUrl>(WrappedComponent: React.ComponentType<P>) => {
  const mapRuntimeToProps = (state: Parameters<typeof getPostPageSectionUrl>[0]) => ({
    sectionUrl: getPostPageSectionUrl(state),
  });

  return connect(mapRuntimeToProps)(
    WrappedComponent as React.ComponentType<WithSectionUrl>,
  ) as React.ComponentType<Omit<P, keyof WithSectionUrl>>;
};

export default withSectionUrl;
